import React, {Fragment} from 'react';
import Icon from "../../../components/Icon";
import {config} from "../../../../config";
import moment from "moment";
import {trancheAge} from "../../../../libs/helper";
import _ from 'lodash';
import * as PropTypes from "prop-types";
import {bindActionCreators} from "redux";
import {fetchUserFriendsSidebar, resetUserFriendsSidebar} from "../../../../creators/user.friends.sidebar";
import {connect} from "react-redux";
import createLink from "../../../../libs/createLink";
import {Link} from "react-router-dom";
import {fetchUserFollowers, resetUserFollowers} from "../../../../creators/user.followers";
import FollowersList from "../../../components/FollowersList";
import Modal from "../../../components/Modal";
import {fetchUserFollowings, resetUserFollowings} from "../../../../creators/user.followings";
import UserStatList from "../../../components/UserStatList";
import LastVisitors from "../../../components/LastVisitors";
import classNames from "classnames";
import {faHeart} from "@fortawesome/free-regular-svg-icons";
import {
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faBirthdayCake,
    faCaretDown,
    faCaretUp,
    faUsers,
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Can} from "../../../../ability-context";
import UserIpList from "../../../components2/userIpList/UserIpList";



class ProfileExpendableDescription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleUserStatListFollower: false,
            toggleUserStatListFollowing: false,
            toggleUserLastVisitors: false,
            toggleUserIp : false,
            seeMore: false
        };
    }

    componentDidMount() {
        if(_.get(this.props,'user._id')){
            this.props.fetchUserFollowings(this.props.user._id, {limit : false});
            this.props.fetchUserFriendsSidebar(this.props.user._id, {limit: 9, page: 1})
            this.props.fetchUserFollowers(this.props.user._id, {limit : false});
        }

    }

    componentWillUnmount() {
        this.props.resetUserFriendsSidebar();
        this.props.resetUserFollowers();
        this.props.resetUserFollowings();
    }

    _toggleSeeMore() {
        this.setState({seeMore: !this.state.seeMore});
    }

    render() {
        let {user} = this.props;
        let infoUser = {
            orientation : [],
            ageRange : [],
            classSex : []
        }
        let informations = _.get(user,"profile.informations") || [];
        informations.map(information => {
            let currentAge = information.birthday ? moment().diff(information.birthday, 'years') : '';
            if(!!information.orientation){
                infoUser.orientation.push(config.genderOrientation[information.orientation]);
            }
            else if(![0,1,2].includes(user.profile.gender)){
                infoUser.orientation.push(config.genderOrientation[0]);
            }
            let ageRange = trancheAge(currentAge, false);
            if(ageRange){
                infoUser.ageRange.push(ageRange);
            }
            /*else if(![0,1,2].includes(user.profile.gender)){
                infoUser.ageRange.push(0);
            }*/

            infoUser.classSex.push(information.sex === 1 ? "woman" : "man");
            return {
                orientation: !!information.orientation ? config.genderOrientation[information.orientation] : '',
                ageRange: trancheAge(currentAge),
                classSex : information.sex === 1 ? "woman" : "man"
            }
        });

        //ageRangesAndOrientations = _.unionBy(ageRangesAndOrientations, _.isEqual);
        let displayFriends = _.get(this.props,"user.setting.displayFriends") || false;
        return (
            <Fragment>
                <div className="card" id="ProfileExpendableDescription">
                    <div className="btn-profile-subnav-wrapper">
                        <div className="profile-description-entry">
                            <span className="profile-description-entry-icon">
                                <Icon type={config.genderClass[user.profile.gender]}/>
                            </span>
                            {config.genderList[user.profile.gender]}
                        </div>
                        {infoUser.ageRange.length ? (
                            <div className="profile-description-entry">
                            <span className="profile-description-entry-icon">
                                <FontAwesomeIcon icon={faBirthdayCake}/>
                            </span>
                                {infoUser.ageRange.map((age, index)=>(
                                    <Fragment key={`age_=${index}`} >
                                        {index === 1 ? " & " : ""}
                                        <span className={infoUser.classSex[index]}>{age === 0 ? "Non renseigné" : age}</span>
                                        {(index + 1 ) === infoUser.ageRange.length ? " Ans" : ""}
                                    </Fragment>
                                ))}
                            </div>
                        ) : null}

                        {!user?.setting?.notDisplayOrientationInProfile && infoUser.orientation.length ? (
                            <div className="profile-description-entry">
                            <span className="profile-description-entry-icon">
                                <FontAwesomeIcon icon={faHeart}/>
                            </span>
                                {infoUser.orientation.map((item, index)=><Fragment key={`orientation_${index}`}>{index === 1 ? " & " : ""}<span className={infoUser.classSex[index]}>{item}</span></Fragment>)}
                            </div>) : null }
                        {/*ageRangesAndOrientations.map((information, index) => (
                            <Fragment key={index}>
                                {information.ageRange && <div className="profile-description-entry">
                                    <span className="profile-description-entry-icon">
                                        <FontAwesomeIcon icon={faBirthdayCake}/>
                                    </span>
                                    <span className={information.classSex}>{information.ageRange}</span>
                                </div>}
                                {!user?.setting?.notDisplayOrientationInProfile && information.orientation && <div className="profile-description-entry">
                                    <span className="profile-description-entry-icon">
                                        <FontAwesomeIcon icon={faHeart}/>
                                    </span>
                                    {information.orientation}
                                </div>}
                            </Fragment>
                        ))*/}
                        {displayFriends ? (<div className="profile-description-entry link">
                            <Link
                                to={this.props.isMe ? createLink('userMeFriends', this.props.user) : createLink('userFriends', this.props.user)}
                                rel={"nofollow"}>
                                <span className="profile-description-entry-icon">
                                    <FontAwesomeIcon icon={faUsers}/>
                                </span>
                                {`${this.props.userFriendsSidebarTotal} ami(e)${this.props.userFriendsSidebarTotal > 1 ? "s" : ""}`}
                            </Link>
                        </div>) : null}

                        <div
                            className={classNames("profile-description-entry", {link: !!this.props.userFollowersTotal})}
                            onClick={() => this.props.userFollowersTotal >= 1 && this.setState({toggleUserStatListFollower: true})}>
                            <span className="profile-description-entry-icon">
                                <FontAwesomeIcon icon={faAngleDoubleRight}/>
                            </span>
                            {this.props.userFollowersTotal || 0} suiveur{this.props.userFollowersTotal >= 2 && 's'}
                        </div>


                        {this.state.seeMore && (
                            <Fragment>
                                <div
                                    className={classNames("profile-description-entry", {link: !!this.props.userFollowingTotal})}
                                    onClick={() => this.props.userFollowingTotal >= 1 && this.setState({toggleUserStatListFollowing: true})}>
                                    <span className="profile-description-entry-icon">
                                        <FontAwesomeIcon icon={faAngleDoubleLeft}/>
                                    </span>
                                    {this.props.userFollowingTotal || 0} suivi{this.props.userFollowingTotal >= 2 && 's'}
                                </div>
                                <Can action={"display-ip"} modelName="User">
                                    <div className={classNames("profile-description-entry link network")} onClick={() => this.setState({toggleUserIp : true})}>
                                        <span className="profile-description-entry-icon">
                                            <Icon type={"network"} className={"icon-network"} />
                                        </span>
                                        {this.props.user.ip || ""}
                                    </div>
                                </Can>
                                <div className="profile-description-entry md-100">
                                    <div className="profile-description-entry-title">
                                        Date d'inscription
                                    </div>
                                    {moment(user.createdAt).format("DD/MM/YYYY")}
                                </div>
                                <div className="profile-description-entry md-100">
                                    <div className="profile-description-entry-title">
                                        Dernière activité
                                    </div>
                                    {moment(user.lastActivity).format("DD/MM/YYYY à HH:mm")}
                                </div>
                                <div className="profile-description-entry md-100">
                                    <div className="profile-description-entry-title">
                                        Visites sur le profil
                                    </div>
                                    {user.count.view.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                                </div>
                                <div className="profile-description-entry md-100">
                                    <div className="profile-description-entry-title">
                                        Type de profil
                                    </div>
                                    {config.role[user.role]}
                                </div>
                                <div className="profile-description-entry md-100">
                                    <div className="profile-description-entry-title">
                                        A propos de moi
                                    </div>
                                    {_.get(user,'profile.description') || ""}
                                </div>
                                {this.props.isMe && (
                                    <div className="profile-description-entry md-100 link"
                                         onClick={() => this.setState({toggleUserLastVisitors: true})}>
                                        Mes derniers visiteurs
                                    </div>
                                )}
                            </Fragment>
                        )}
                    </div>
                    <div className="profile-description-see-more" onClick={this._toggleSeeMore.bind(this)}>
                        {this.state.seeMore ? (
                            <span><FontAwesomeIcon icon={faCaretUp}/> Moins</span>
                        ) : (
                            <span><FontAwesomeIcon icon={faCaretDown}/> Plus</span>
                        )}
                    </div>
                </div>

                <Modal toggle={this.state.toggleUserLastVisitors}
                       handleClose={() => this.setState({toggleUserLastVisitors: false})}>
                    <LastVisitors userId={this.props.user._id}
                                  handleClose={() => this.setState({toggleUserLastVisitors: false})}/>
                </Modal>
                <Modal toggle={this.state.toggleUserStatListFollower}
                       handleClose={() => this.setState({toggleUserStatListFollower: false})}>
                    <FollowersList User={this.props.user}
                                   handleClose={() => this.setState({toggleUserStatListFollower: false})}/>
                </Modal>
                <Modal toggle={this.state.toggleUserStatListFollowing}
                       handleClose={() => this.setState({toggleUserStatListFollowing: false})}>
                    <UserStatList
                        type="following"
                        following={this.props.userFollowing}
                        handleClose={() => this.setState({toggleUserStatListFollowing: false})}
                        User={this.props.user}
                    />
                </Modal>
                <Modal toggle={this.state.toggleUserIp}
                       handleClose={() => this.setState({toggleUserIp: false})}>
                    <UserIpList
                        handleClose={() => this.setState({toggleUserIp: false})}
                        userId={this.props.user._id}
                    />
                </Modal>
            </Fragment>
        )
    }
}

ProfileExpendableDescription.propTypes = {user: PropTypes.any}

const mapStateToProps = (state) => {
    return {
        userFriendsSidebar: state.userFriendsSidebar.data,
        userFriendsSidebarInitialized: state.userFriendsSidebar,
        userFriendsSidebarTotal: state.userFriendsSidebar.total,
        userFollowers: state.userFollowers.data,
        userFollowersLoading: state.userFollowers.loading,
        userFollowersInitialized: state.userFollowers.initialized,
        userFollowersTotal: state.userFollowers.total,
        userFollowing: state.userFollowings.data,
        userFollowingLoading: state.userFollowings.loading,
        userFollowingInitialized: state.userFollowings.initialized,
        userFollowingTotal: state.userFollowings.total
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserFriendsSidebar,
    resetUserFriendsSidebar,
    fetchUserFollowers,
    resetUserFollowers,
    fetchUserFollowings,
    resetUserFollowings
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(ProfileExpendableDescription);